<template>
<!--TODO: @hamid add overflow -->
  <div class="container mt-3 TODO">
    <ul class="nav nav-tabs" id="myTab" role="tablist">
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="home-tab"
          data-bs-toggle="tab"
          data-bs-target="#home"
          type="button"
          role="tab"
          aria-controls="home"
          aria-selected="true"
          v-bind:class="currentComponent == 'Members' ? 'active' : ''"
          @click="switchComponent('Members')"
        >Members</button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="profile-tab"
          data-bs-toggle="tab"
          data-bs-target="#profile"
          type="button"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
          v-bind:class="currentComponent == 'Rooms' ? 'active' : ''"
          @click="switchComponent('Rooms')"
        >Topics</button>
      </li>
      <li class="nav-item" role="presentation">
        <button
          class="nav-link"
          id="contact-tab"
          data-bs-toggle="tab"
          data-bs-target="#contact"
          type="button"
          role="tab"
          aria-controls="contact"
          aria-selected="false"
          v-bind:class="currentComponent == 'Messages' ? 'active' : ''"
          @click="switchComponent('Messages')"
        >Messages</button>
      </li>
    </ul>
    <div class="tab-content" id="myTabContent">
      <div class="tab-pane fade show active" id="home" role="tabpanel" aria-labelledby="home-tab">
        <elAdminMembers v-if="currentComponent == 'Members'" />
      </div>
      <div class="tab-pane fade" id="profile" role="tabpanel" aria-labelledby="profile-tab">
        <elAdminRooms v-if="currentComponent == 'Rooms'" />
      </div>
      <div class="tab-pane fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
        <elAdminMessages v-if="currentComponent == 'Messages'" />
      </div>
    </div>
  </div>
</template>

<script>
import elAdminMembers from "./AdminMembers.vue";
import elAdminRooms from "./AdminRooms.vue";
import elAdminMessages from "./AdminMessages.vue";
export default {
  name: "Dashboard",

  components: {
    elAdminMembers,
    elAdminRooms,
    elAdminMessages,
  },

  data() {
    return {
      currentComponent: "Members",
    };
  },

  mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    switchComponent(component) {
      this.currentComponent = component;
    },
  },
};
</script>
